import React from "react";
import { Row } from "react-bootstrap";
import { RadioGroup } from "../../../genericComponents";

function CustomerSurvey20() {
  return (
    <Row>
      <RadioGroup
        label="Escolaridade?"
        name="education"
        options={[
          {value: "Analfabeto(a)", label: "Analfabeto(a)" },
          {value: "Ensino Fundamental Completo", label: "Ensino Fundamental Completo" },
          {value: "Ensino Fundamental Incompleto", label: "Ensino Fundamental Incompleto" },
          {value: "Ensino Médio Completo", label: "Ensino Médio Completo" },
          {value: "Ensino Médio Incompleto", label: "Ensino Médio Incompleto" },
          {value: "Ensino Superior Completo", label: "Ensino Superior Completo" },
          {value: "Ensino Superior Incompleto", label: "Ensino Superior Incompleto" }
        ]}
        required='O campo "Escolaridade?" é obrigatório.'
        inline
      />
    </Row>
  );
}

export default React.memo(CustomerSurvey20);
